"use client";

import type { ReactNode } from "react";
import { usePathname } from "next/navigation";
import { buildWhatsAppContactUrl, getWhatsAppContactContext } from "@/lib/contact-links";

type WhatsAppContactLinkProps = {
  children?: ReactNode;
  className?: string;
  label?: string;
  showLabel?: boolean;
  labelClassName?: string;
};

function contactHandoffHref(pathname: string | null): string {
  return buildWhatsAppContactUrl(pathname);
}

export default function WhatsAppContactLink({
  children,
  className,
  label = "WhatsApp",
  showLabel = true,
  labelClassName,
}: WhatsAppContactLinkProps) {
  const pathname = usePathname();
  const context = getWhatsAppContactContext(pathname);
  const href = contactHandoffHref(pathname);

  return (
    <a
      href={href}
      className={className}
      aria-label={`${label} SEOH from the ${context.pageName}`}
    >
      {children ?? (
        <>
          <i className="bi bi-phone" aria-hidden="true" />
          <span className={showLabel ? labelClassName : "visually-hidden"}>{label}</span>
        </>
      )}
    </a>
  );
}
